<template>
    <el-dialog
        :close-on-click-modal="true"
        :close-on-press-escape="false"
        :modal="false"
        :show-close="false"
        :visible.sync="dialogVisible"
        center
        class="auto-dialog-container"
        top="0"
        width="500px">
        <div class="dialog-container flex flex-direction">
            <div class="dialog-header flex align-center justify-between padding-lr-sm">
                <div class="dialog-title">常见问题</div>
                <i class="dialog-close el-icon-close " @click="cancel"></i>
            </div>
            <div class="message-list flex-sub" ref="list">
                <div v-for="(item,index) in mlists" :key="index">
                    <div v-if="item.role === 1" class="revice-item">
                        <el-avatar class="flex-shrink" icon="el-icon-question"></el-avatar>
                        <div v-if="item.type === 1" class="message">
                            {{ item.message }}
                        </div>
                        <div v-if="item.type === 2" class="list">
                            <div class="title">你是不是想了解：</div>
                            <div class="question" v-for="question in item.message" :key="question.id"
                            @click="submitItem(question)">
                                {{question.title}}
                            </div>
                        </div>
                    </div>
                    <div v-else class="send-item">
                        <div class="message">
                            {{ item.message }}
                        </div>
                        <el-avatar class="flex-shrink" icon="el-icon-user-solid"></el-avatar>
                    </div>
                </div>
            </div>
            <div class="dialog-operate flex align-center justify-center">
                <el-autocomplete v-model="content"
                                 :fetch-suggestions="querySearch"
                                 :trigger-on-focus="false"
                                 class="flex-sub"
                                 placeholder="请输入您想咨询的问题~"
                                 value-key="title"
                                 @keydown.enter.native="submitForm"
                                 @keyup.enter="submitForm"
                                 @select="handleSelect">
                </el-autocomplete>
                <el-button :disabled="content.length < 1" :loading="loading" circle class="margin-left-sm"
                           icon="el-icon-s-promotion"
                           type="info"
                           @click="submitForm"></el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import {getCommonProblem, getCommonProblemDetail} from '@/api/member'

export default {
    name: "AutoOpinionDialog",
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        id: { //详情ID
            type: Number,
        },
    },
    data() {
        return {
            loading: false,
            content: '',
            restaurants: [],
            mlists: []
        }
    },
    created() {
        this.getMessage('')
    },
    methods: {
        querySearch(queryString, cb) {
            var restaurants = this.restaurants;
            var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        createFilter(queryString) {
            return (restaurant) => {
                return (
                    restaurant.title
                        .toLowerCase()
                        .indexOf(queryString.toLowerCase()) !== -1
                );
            };
        },
        handleSelect(item) {
            this.submitItem(item)
        },
        submitItem(item){
            this.mlists.push({
                time: new Date().getTime(),
                role: 2,//1 kefu 2 用户
                type: 1,//1 普通消息 2 列表消息
                message: item.title
            })
            this.getCommonProblemDetail(item.id)
            this.clearContent()
        },
        submitForm() {
            if (!this.content) return
            this.mlists.push({
                time: new Date().getTime(),
                role: 2,//1 kefu 2 用户
                type: 1,//1 普通消息 2 列表消息
                message: this.content
            })
            this.getMessage(this.content)
            this.clearContent()
        },
        scrollBy(){
          this.$nextTick(()=>{
              this.$refs.list.scrollBy(0,this.$refs.list.scrollHeight + 1000)
          })
        },
        async getMessage(content) {
            this.loading = true
            let _data = await getCommonProblem(content)
            this.loading = false
            if (_data.status === 200) {
                if (!content) {
                    this.restaurants = _data.data
                } else {
                    this.mlists.push({
                        time: new Date().getTime(),
                        role: 1,//1 kefu 2 用户
                        type: _data.data.length === 0 ? 1 : 2,//1 普通消息 2 列表消息
                        message: _data.data.length === 0 ? '暂时没有找到相关答案，可以联系客服进行咨询。' : _data.data
                    })
                }
                this.scrollBy()
            }
        },
        async getCommonProblemDetail(id) {
            let _data = await getCommonProblemDetail(id)
            if (_data.status === 200) {
                this.mlists.push({
                    time: new Date().getTime(),
                    role: 1,//1 kefu 2 用户
                    type: 1,//1 普通消息 2 列表消息
                    message: _data.data.content
                })
                this.scrollBy()
            }
        },
        cancel() {
            this.mlists = []
            this.clearContent()
            this.$emit('watchState', false)
        },
        clearContent() {
            this.content = ''
        },
        init() {
            this.mlists.push({
                time: new Date().getTime(),
                role: 1,//1 kefu 2 用户
                type: 1,//1 普通消息 2 列表消息
                message: '我是你的在线客服，我可以帮你解答使用中遇到的疑问！'
            })
        },
    },
    watch: {
        dialogVisible() {
            if (this.dialogVisible) {
                this.loading = false
                this.init()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.auto-dialog-container {
    .dialog-container {
        height: 600px;

        .dialog-header {
            height: 55px;
            background: #0a2240;

            .dialog-title {
                font-size: 18px;
                font-weight: bold;
                color: #ffffff;
            }

            .dialog-close {
                font-size: 21px;
                color: #ffffff;
                font-weight: bold;
                cursor: pointer;
            }
        }

        .dialog-content {
            padding: 40px 80px;
            height: 605px;

            .title {
                font-size: 24px;
                font-weight: bold;
                color: #0a2240;
                text-align: center;
            }

            .content {
                margin-top: 38px;
                overflow-y: scroll;

                &::-webkit-scrollbar {
                    display: none
                }
            }

            .time {
                font-size: 16px;
                color: #0a2240;
                margin-top: 16px;
            }
        }

        .message-list {
            background: #e0e0e0;
            display: flex;
            flex-direction: column;
            padding: 12px;
            overflow-y: scroll;
            .send-item {
                display: flex;
                justify-content: flex-end;
                margin-bottom: 20px;

                .message {
                    overflow: hidden;
                    min-width: 1px;
                    background: #fff;
                    border-radius: 4px;
                    font-size: 14px;
                    color: #333333;
                    padding: 8px 12px;
                    line-height: 1.5;
                    white-space: pre-wrap;
                    word-wrap: break-word;
                    overflow-wrap: break-word;
                    margin-right: 12px;
                    margin-left: 50px;
                }
            }

            .revice-item {
                display: flex;
                margin-bottom: 20px;

                .list {
                    background: #fff;
                    border-radius: 4px;
                    padding: 8px 12px;
                    margin-left: 12px;
                    margin-right: 50px;
                    display: flex;
                    flex-direction: column;
                    .title {
                        font-size: 14px;
                        font-weight: 700;
                        color: #333333;
                        margin-bottom: 10px;
                    }

                    .question {
                        font-size: 14px;
                        cursor: pointer;
                        padding: 8px;
                        border-top: 1px solid #f0f0f0;
                        line-height: 22px;
                        color: #0d7fd7;
                    }
                }

                .message {
                    overflow: hidden;
                    min-width: 1px;
                    background: #fff;
                    border-radius: 4px;
                    font-size: 14px;
                    color: #333333;
                    padding: 8px 12px;
                    line-height: 1.5;
                    white-space: pre-wrap;
                    word-wrap: break-word;
                    overflow-wrap: break-word;
                    margin-left: 12px;
                    margin-right: 50px;
                }
            }
        }

        .dialog-operate {
            background: #FFFFFF;
            padding: 20px;

            .operate {
                width: 200px;
                height: 40px;
                font-size: 16px;
                background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                linear-gradient(#ff9600, #ff9600);
                background-blend-mode: normal, normal;
                color: #ffffff;

                &.black {
                    background: #0a2240 none;
                }
            }

            .operate + .operate {
                margin-left: 80px;
            }
        }

        .dialog-footer {
            height: 40px;
            background-color: #e7eff9;
            padding: 0 20px;
            border-radius: 0 0 10px 10px;

            .content {
                font-size: 16px;
                color: #8b9fbe;
            }
        }
    }
}
</style>